module.exports = __webpack_public_path__ + "media/country_flags/sb-6e8adb7c.png";